import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { LogoMain } from '../'
import { browserUtils } from '../../utils'
import './SidebarContainer.sass'


class SidebarContainer extends Component {
  state = {
    isExpanded: false
  }

  constructor() {
    super()
    this._collapseSidebar = this.collapseSidebar.bind(this)
    this._expandSidebar = this.expandSidebar.bind(this)
    this._toggleSidebar = this.toggleSidebar.bind(this)
  }

  // onMouseEnter and onMouseLeave are translated to click events on mobile
  // which we want to ignore on tablet to avoid click and mouse events fighting each other
  collapseSidebar() {
    if (browserUtils.isMobileOrTabletDevice()) { return }
    this.setState({ isExpanded: false })
  }

  expandSidebar() {
    if (browserUtils.isMobileOrTabletDevice()) { return }
    this.setState({ isExpanded: true })
  }

  toggleSidebar() {
    this.setState({ isExpanded: !this.state.isExpanded })
  }

  render() {
    const { isExpanded } = this.state
    const { className } = this.props

    return (
      <aside
        className={`sidebar-container ${className}`}
        onMouseEnter={this._expandSidebar}
        onMouseLeave={this._collapseSidebar}
      >
        <LogoMain containerClassName="logo" />
        { this.props.children(isExpanded, this._toggleSidebar) }
      </aside>
    )
  }
}

SidebarContainer.propTypes = {
  children: PropTypes.func,
  className: PropTypes.string,
}

SidebarContainer.defaultProps = {
  className: '',
}

export default SidebarContainer
